import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.202 6.013a.667.667 0 0 0 0 1.307l.133.013h.007a.667.667 0 0 0 0-1.334h-.007z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.887 3.333c-.53 0-1.04.211-1.414.586L4.667 7.726a2.276 2.276 0 0 0 0 3.215l2.395 2.394a2.274 2.274 0 0 0 3.215 0l3.805-3.806a2 2 0 0 0 .587-1.413V5.333a2 2 0 0 0-2-2zm2.782 1.334a.666.666 0 0 1 .666.666v2.782a.67.67 0 0 1-.111.37l-.084.101-3.807 3.807-.068.062a.94.94 0 0 1-1.26-.062L5.61 9.998l-.063-.069a.94.94 0 0 1 0-1.191l.063-.069 3.806-3.806a.67.67 0 0 1 .472-.196z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.474 3.529a.67.67 0 0 0-.839-.085l-.104.085L2.469 6.59l-.132.14a3.88 3.88 0 0 0 .132 5.348l1.062 1.06.104.086a.668.668 0 0 0 .839-1.028l-1.062-1.062a2.55 2.55 0 0 1 0-3.601l3.062-3.061.085-.104a.67.67 0 0 0-.085-.84"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })